import Input from 'antd/lib/input';
import styled from 'styled-components';

const CustomInput = styled(Input)`
  padding: 1px 7px;
  font-size: 13px;
`;

export default CustomInput;
